import { DOCUMENT_GROUP_NAMES } from '@/finsight/domain/DocumentGroup';

type TGroupId = string | null;

export const makeEmptyGroupIds = (response) => {
  const researchGroups = {
    [DOCUMENT_GROUP_NAMES.ALL]: response.all,
    ...response.byGroup,
  };

  return Object.keys(researchGroups).reduce(
      (groupIds: TGroupId[], groupId: string) => {
        if (researchGroups[groupId].count === 0) {
          groupIds.push(groupId === DOCUMENT_GROUP_NAMES.ALL ? null : groupId);
        }
        return groupIds;
      }, []);
};
